import { FilterName, mttDefaultState } from '@swf/poker';

import type { PokerMultiTableTournamentsState } from './types';

export const INITIAL_SELECTED_FILTERS = {
  [FilterName.BuyIn]: [],
  [FilterName.Games]: [],
  [FilterName.Speed]: [],
  [FilterName.TableSize]: []
};

export const defaultState: PokerMultiTableTournamentsState = {
  ...mttDefaultState,
  activeFilters: { upcomingOnly: true },
  activeUiFilters: INITIAL_SELECTED_FILTERS
};
